import { render, staticRenderFns } from "./IotAlertList.vue?vue&type=template&id=70e8b4fd&scoped=true&"
import script from "./IotAlertList.vue?vue&type=script&lang=js&"
export * from "./IotAlertList.vue?vue&type=script&lang=js&"
import style0 from "./IotAlertList.vue?vue&type=style&index=0&id=70e8b4fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8b4fd",
  null
  
)

export default component.exports